import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'

/* Components */
import SliderModal from '../../../components/slider-modal'
import ProductView from '../../../partials/product-view'

/* Hooks */
import {useProductViewModal} from '../../../hooks/use-product-view-modal'
import {usePDPSearchParams} from '../../../hooks/use-pdp-search-params'
import {useHistory} from 'react-router-dom'
import {trackPsdpColorSelectProductTile} from '../../../tracking/analytics'
import useEffectEvent from '../../../hooks/use-effect-event'

const Product = ({initialProduct, productSetIndex, onClose, onAddToCartClick}) => {
    const {product, isFetching} = useProductViewModal(initialProduct, false, true, productSetIndex)
    const history = useHistory()

    const [allParams, productParams] = usePDPSearchParams(
        initialProduct?.id + '_' + productSetIndex
    )

    const onChangedMaterial = (value) => {
        productParams.set('pid', value)
        allParams.set(initialProduct.masterId + '_' + productSetIndex, productParams.toString())

        history.replace({search: allParams.toString()})
    }

    const [variantChanged, setVariantChanged] = useState(false)
    const onVariantChange = useEffectEvent((changedProduct) => {
        // skip the first time
        if (!variantChanged) {
            setVariantChanged(true)
            return
        }
        trackPsdpColorSelectProductTile(changedProduct)
    })
    useEffect(() => {
        onVariantChange(product)
    }, [product, onVariantChange])

    return (
        <ProductView
            imageSize="sm"
            product={product}
            isProductLoading={isFetching}
            isProductASet
            productSetIndex={productSetIndex}
            onClick={onAddToCartClick}
            onChangedMaterial={onChangedMaterial}
            onClose={onClose}
        />
    )
}

Product.propTypes = {
    initialProduct: PropTypes.object,
    isProductASet: PropTypes.bool,
    productSetIndex: PropTypes.number,
    onClose: PropTypes.func,
    onAddToCartClick: PropTypes.func
}

const ProductSetModal = ({products, onAddToCartClick, onClose, ...props}) => {
    /* If there are no products, don't show component at all */
    if (!products) return null

    return (
        <SliderModal onClose={onClose} {...props}>
            {products.map((product, index) => (
                <Product
                    key={index}
                    initialProduct={product}
                    productSetIndex={index}
                    onAddToCartClick={onAddToCartClick}
                    onClose={onClose}
                />
            ))}
        </SliderModal>
    )
}

ProductSetModal.propTypes = {
    products: PropTypes.array,
    onClose: PropTypes.func,
    onAddToCartClick: PropTypes.func
}

export default ProductSetModal
